$(document).ready(function () {
  if ($(window).width() < 768) {
    $(".template-index  .multi-column__grid").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
      dots: false,
      adaptiveHeight: true,
    });
  }
});

// Homepage Loading Screen Functionality
function initHomepageLoadingScreen() {
  // console.log('DEBUG: Loading screen initialization running');
  
  // Temporarily clear the session storage for testing
  sessionStorage.removeItem('lwc-loading-seen');
  
  // Check if this is the first visit in this session
  const hasSeenLoading = sessionStorage.getItem('lwc-loading-seen');
  const loadingScreen = document.getElementById('homepage-loading-screen');
  
  // console.log('DEBUG: hasSeenLoading (after clearing):', hasSeenLoading);
  // console.log('DEBUG: loadingScreen element:', loadingScreen);
  
  if (!hasSeenLoading && loadingScreen) {
    // console.log('DEBUG: Showing loading screen');
    
    // Show loading screen
    loadingScreen.style.display = 'flex';
    
    // Function to hide loading screen
    function hideLoadingScreen() {
      // console.log('DEBUG: Hiding loading screen');
      loadingScreen.classList.add('fade-out');
      
      setTimeout(function () {
        loadingScreen.style.display = 'none';
        // Mark as seen for this session
        sessionStorage.setItem('lwc-loading-seen', 'true');
        // console.log('DEBUG: Loading screen hidden and session flag set');
      }, 800); // Match the CSS transition duration
    }
    
    // Wait for page to load and show for minimum 2 seconds
    let pageLoaded = false;
    let minTimeElapsed = false;
    
    // Set minimum display time
    setTimeout(function () {
      // console.log('DEBUG: Minimum time elapsed (2 seconds)');
      minTimeElapsed = true;
      if (pageLoaded) {
        hideLoadingScreen();
      }
    }, 1000); // 1 second
    
    // Check when page is fully loaded
    function onPageLoad() {
      // console.log('DEBUG: Page loaded');
      pageLoaded = true;
      if (minTimeElapsed) {
        hideLoadingScreen();
      }
    }
    
    // Handle different loading states
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
    }
    
    // Fallback: hide after maximum 8 seconds regardless
    setTimeout(function () {
      // console.log('DEBUG: Fallback timeout triggered');
      if (loadingScreen && !loadingScreen.classList.contains('fade-out')) {
        hideLoadingScreen();
      }
    }, 8000);
    
  } else if (loadingScreen) {
    // console.log('DEBUG: Loading screen exists but hiding immediately (already seen)');
    // Hide immediately if already seen this session
    loadingScreen.style.display = 'none';
  }
}
